import { render, staticRenderFns } from "./EmblavementCard.vue?vue&type=template&id=117de184"
import script from "./EmblavementCard.vue?vue&type=script&lang=js"
export * from "./EmblavementCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports